export default __webpack_public_path__ + "static/media/unstake-btn.bbe3b712.svg";